import Index from "@/zh-website/src/views/Recruit/index.vue";
import Recruit from "@/zh-website/src/views/Recruit/RecruitIndex.vue";
import RecruitSocial from "@/zh-website/src/views/Recruit/RecruitSocial.vue";
import RecruitCampus from "@/zh-website/src/views/Recruit/RecruitCampus.vue";
import Resume from "@/zh-website/src/views/Recruit/Resume.vue";
export const RecruitRoute = {
  path: "/home/recruit",
  name: "Recruit",
  component: Index,
  redirect: "/home/recruit/page",
  meta: {
    type: 1,
    title: "招聘中心-浙江华为门户网站",
    serial: 3
  },
  children: [
    {
      path: "/home/recruit/page",
      name: "Index",
      component: Recruit,
      meta: {
        type: 1,
        title: "招聘中心-浙江华为门户网站",
        serial: 3
      }
    },
    {
      path: "/home/recruit/social",
      name: "RecruitSocial",
      component: RecruitSocial,
      meta: {
        type: 1,
        title: "社会招聘-浙江华为门户网站",
        serial: 3
      }
    },
    {
      path: "/home/recruit/campus",
      name: "RecruitCampus",
      component: RecruitCampus,
      meta: {
        type: 1,
        title: "校园招聘-浙江华为门户网站",
        serial: 3
      }
    },
    {
      path: "/home/recruit/resume/:type/:aid",
      name: "Resume",
      component: Resume,
      meta: {
        type: 1,
        title: "简历-浙江华为门户网站",
        serial: 3
      }
    }
  ]
};
